<script lang="ts">
  // ============================================================
  // ✅ Svelte 5 Runes Component
  // ============================================================
  // Block/Unblock toggle button

  import { apiClient } from '../../utils/api';

  interface Props {
    userId: number;
    initialBlocked?: boolean;
    size?: 'sm' | 'md';
    onToggle?: (isBlocked: boolean) => void;
  }

  let { userId, initialBlocked = false, size = 'sm', onToggle }: Props = $props();
  // svelte-ignore state_referenced_locally
  const initialBlockedValue = initialBlocked;

  let isBlocked = $state(initialBlockedValue);
  let isLoading = $state(false);

  async function toggleBlock() {
    if (isLoading) return;
    isLoading = true;

    try {
      if (isBlocked) {
        // Find the block ID first, then delete
        const checkRes = await apiClient.get<{ isBlocked: boolean; blockId?: number }>('/api/v1/blocks/check', {
          params: { userId }
        });
        if (checkRes && 'blockId' in checkRes && checkRes.blockId) {
          await apiClient.delete(`/api/v1/blocks/${checkRes.blockId}`);
        }
        isBlocked = false;
      } else {
        await apiClient.post('/api/v1/blocks', { blockedId: userId });
        isBlocked = true;
      }
      onToggle?.(isBlocked);
    } catch (err) {
      console.error('Block toggle failed:', err);
    } finally {
      isLoading = false;
    }
  }

  const btnSize = $derived(size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm');
</script>

<button
  onclick={toggleBlock}
  disabled={isLoading}
  class="{btnSize} font-medium rounded-lg transition-all duration-200 disabled:opacity-50
    {isBlocked
      ? 'bg-surface-tertiary text-content-secondary border border-gray-300 dark:border-dark-border hover:bg-green-50 hover:text-green-600'
      : 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-800 hover:bg-red-100'}"
>
  {#if isLoading}
    <svg class="animate-spin w-3.5 h-3.5 inline-block" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
    </svg>
  {:else if isBlocked}
    차단 해제
  {:else}
    차단
  {/if}
</button>
